import { render } from "./indexConfigClickSignComponent.vue?vue&type=template&id=022f9564&scoped=true"
import script from "./indexConfigClickSignComponent.vue?vue&type=script&lang=js"
export * from "./indexConfigClickSignComponent.vue?vue&type=script&lang=js"

import "./indexConfigClickSignComponent.vue?vue&type=style&index=0&id=022f9564&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022f9564"]])

export default __exports__